(function () {
    'use strict';

    angular
        .module('sempraWebapp')
        .controller('createUpdateUserGroupController', createUpdateUserGroupController);

    /** @ngInject */
    function createUpdateUserGroupController(   $scope, dialogsService, $stateParams, userGroupActions, CreateUpdateUserGroupViewModel,
                                                $timeout, sempraUsersActions, hostProtocol, hostDomain, Upload, $mdDialog) {
        var vm = this;
        var newGroupId;

        vm.usersPromise = null;
        vm.searchUserValidation = false;

        vm.createUpdateGroup = function ($event) {
            vm.group.groupName = vm.group.groupName.trim();
            if (vm.group.groupName !== '') {
                vm.group.isEditMode
                    ? userGroupActions.updateUserGroup(vm.group.id, vm.group.groupName).then(onGroupSaveUpdateSuccess)
                    : userGroupActions.createUserGroup(vm.group.groupName, vm.group.groupType).then(onGroupSaveUpdateSuccess);
            }
            var target = $event.target;
            target.blur();
        };

        vm.addUserToGroup = function (text) {
            $scope.searchUserForm.userName.$setUntouched();
            checkUser(text).then(function(val){
                if(val.length > 0) {
                    // check if user is already in that group
                    if(!checkIfUserIsInGroup(val[0].id)){
                        userGroupActions.addUserToUserGroup(vm.group.id, val[0].id).then(function () {
                            vm.group.onUserAddedToGroup();
                            refreshGroupUsers();
                        });
                    }else{
                        // show error msg
                        showSearchUserValidation();
                        hideSearchUserValidation();
                    }
                } else {
                    dialogsService.showOkDialog('MISSING_USER', 'USER_NOT_ON_LIST').then();
                }
            });
        };

        vm.uploadFile = function(file, errFiles) {
            /* eslint-disable */
            $scope.f = file;
            $scope.errFile = errFiles && errFiles[0];
            var id = ($stateParams.id) ? $stateParams.id : newGroupId;
            if (file) {
                file.upload = Upload.upload({
                    url: hostProtocol + '://' + hostDomain + '/api/userGroups/' + id,
                    data: {file: file}
                });

                file.upload.then(function (response) {
                    if(response.data.length > 0) {
                        vm.uknownUserList = unknownUser(response.data);
                    }
                    // Refresh user group ================================================
                    userGroupActions.getUserGroupById(id).then(function (groupJson) {
                        vm.group.refreshGroup(groupJson);
                    });
                    refreshGroupUsers();
                    // ===================================================================
                    $timeout(function () {
                        file.result = response.data;
                    });
                }, function (response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }
            /* eslint-enable */
        }

        function unknownUser (list) {
            var data = [];
            var user = {};
            list.forEach(function(item, index){
                if(item.length > 0) {
                    user = {
                        id: index + 1,
                        email: item
                    }
                    data.push(user);
                }
            });
            return data;
        }

        function checkUser (text) {
            return sempraUsersActions.searchSempraUsers(text);
        }

        vm.addUserByTelephoneToGroup = function () {
            userGroupActions.addUserToUserGroup(vm.group.id, vm.group.selectedUserByTelephone.id).then(function () {
                vm.group.onUserByTelephoneAddedToGroup();
                refreshGroupUsers();
            });
        };

        vm.removeUserFromGroup = function (groupUser) {
            dialogsService.showConfirmDialog('DELETE_USER', 'DELETE_USER_FROM_USER_GROUP_QUESTION', 'OK').then(function () {
                userGroupActions.removeUserFromUserGroup(groupUser.id).then(function () {
                    refreshGroupUsers();
                });
            });
        };

        vm.onUsersPageChange = function (page, limit) {
            vm.group.onUsersPaginationChange(page, limit);
            refreshGroupUsers();
        };

        vm.onUsersOrderChange = function (order) {
            vm.group.onUsersOrderingChange(order);
            refreshGroupUsers();
        };

        init();

        function init() {
            vm.group = new CreateUpdateUserGroupViewModel($stateParams.id);

            // Always use DEFAULT group type
            vm.group.groupType = 'DEFAULT';

            if ($stateParams.id) {
                vm.group.setGroupId($stateParams.id);
                userGroupActions.getUserGroupById(vm.group.id).then(function (groupJson) {
                    vm.group.refreshGroup(groupJson);
                });
                refreshGroupUsers();
            }

            $scope.$on('$destroy', destroy);
        }

        function refreshGroupUsers () {
            vm.usersPromise = userGroupActions.getActiveUsersForUserGroup(vm.group.id,
                vm.group.usersPage - 1,
                vm.group.usersPageSize,
                vm.group.usersOrderBy,
                vm.group.usersOrder).then(function (usersJson) {
                    vm.group.refreshUsersForGroup(usersJson);
                });
        }

        function onGroupSaveUpdateSuccess(responseId) {
            newGroupId = responseId;
            if (!vm.group.isEditMode) {
                vm.id = responseId;
                vm.group.id = responseId;
                vm.group.isEditMode = true;
            }
        }

        function checkIfUserIsInGroup(userId){
            for(var i=0; i < vm.group.groupUsers.length; i++){
                if(vm.group.groupUsers[i].user.id === userId){
                    return true;
                }
            }
            return false;
        }

        function showSearchUserValidation(){
            vm.searchUserValidation = true;
        }

        function hideSearchUserValidation(){
            $timeout(function(){
                vm.searchUserValidation = false
            }, 3000);
        }

        function destroy() {
            vm.group.destroy();
        }

        //List of uknown users (after *.csv import)

        vm.showListOfUknownUsers = function(ev) {
            $mdDialog.show({
              controller : uknownListOfUsersController,
              controllerAs : 'vm',
              bindToController : true,
              templateUrl: 'app/createUpdateUserGroup/uknownUserListModal.html',
              /* eslint-disable */
              parent: angular.element(document.body),
              /* eslint-enable */
              targetEvent: ev,
              locals : {userList : vm.uknownUserList},
              clickOutsideToClose:true
            });
        };

        function uknownListOfUsersController($mdDialog){
            /* eslint-disable */
            var that = this;
            /* eslint-enable */
            that.closeDialog = function(){
                $mdDialog.hide();
            }

        }

    }
})();
